import React from "react";
import Container from "react-bootstrap/Container";

const Footer = () => {
  const bgStyle = { backgroundColor: "#f8fafc" };

  return (
    <footer style={bgStyle} className="py-4 text-center">
      <Container>
        <small style={{ color: "#94a3b8" }}>
          <i className="fas fa-code" /> with <i className="fas fa-heart" /> by{" "}
          <a
            rel="noopener"
            href="https://github.com/jancarloonce"
            aria-label="My GitHub"
            style={{ color: "#6366f1", textDecoration: "none", fontWeight: 600 }}
          >
            Jan Carlo Once
          </a>{" "}
          using <i className="fab fa-react" />
        </small>
      </Container>
    </footer>
  );
};

export default Footer;